
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11.86 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M10.79 0H11a1 1 0 01.8.71V1.14a2.31 2.31 0 01-.24.47L7.21 7v.07l4.23 5.13a1.66 1.66 0 01.37.66v.45a.93.93 0 01-.47.57c-.09 0-.19.08-.28.12h-.35a1.15 1.15 0 01-.6-.37L5.93 8.55a.71.71 0 01-.07.09l-4.08 4.95a1 1 0 01-.6.39H.82a1 1 0 01-.54-1.6C1.54 10.79 4.49 7.21 4.66 7v-.06L.23 1.62A1 1 0 01.76 0h.37a1 1 0 01.61.35l4.19 5.11.07-.07 4.13-5a1 1 0 01.54-.39z"}})])
          )
        }
      }
    